import { CSSProps } from "@lib/types/generic";
import React from "react";

export default function Instagram(props: CSSProps) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M20.1797 5.92844C20.1797 5.13081 19.5333 4.48676 18.7386 4.48676C17.9439 4.48676 17.2969 5.13081 17.2969 5.92844C17.2969 6.72314 17.9439 7.36719 18.7386 7.36719C19.5333 7.36719 20.1797 6.72314 20.1797 5.92844"
        fill="url(#paint0_linear_4092_44236)"
      />
      <path
        d="M22.0986 17.1824C22.0452 18.3525 21.8495 18.9883 21.687 19.4105C21.4688 19.9703 21.2084 20.3706 20.7862 20.7905C20.3687 21.2104 19.9684 21.4701 19.4085 21.686C18.9863 21.8509 18.3482 22.0472 17.1781 22.1029C15.9131 22.1587 15.5383 22.1706 12.3305 22.1706C9.12573 22.1706 8.74793 22.1587 7.48297 22.1029C6.31292 22.0472 5.67776 21.8509 5.25549 21.686C4.6927 21.4701 4.29537 21.2104 3.8755 20.7905C3.45264 20.3706 3.19231 19.9703 2.97703 19.4105C2.81451 18.9883 2.61587 18.3525 2.56543 17.1824C2.50378 15.9175 2.49248 15.5367 2.49248 12.3355C2.49248 9.12769 2.50378 8.74989 2.56543 7.48492C2.61587 6.31487 2.81451 5.67972 2.97703 5.25388C3.19231 4.69465 3.45264 4.2967 3.8755 3.87683C4.29537 3.45757 4.6927 3.1972 5.25549 2.97899C5.67776 2.81353 6.31292 2.62018 7.48297 2.56445C8.74793 2.50867 9.12573 2.49444 12.3305 2.49444C15.5383 2.49444 15.9131 2.50867 17.1781 2.56445C18.3482 2.62018 18.9863 2.81353 19.4085 2.97899C19.9684 3.1972 20.3687 3.45757 20.7862 3.87683C21.2084 4.2967 21.4688 4.69465 21.687 5.25388C21.8495 5.67972 22.0452 6.31487 22.0986 7.48492C22.1573 8.74989 22.1715 9.12769 22.1715 12.3355C22.1715 15.5367 22.1573 15.9175 22.0986 17.1824V17.1824ZM24.2591 7.38649C24.2004 6.10787 23.9987 5.23431 23.6992 4.47346C23.3944 3.6841 22.9858 3.01515 22.3168 2.34619C21.6509 1.68021 20.9819 1.27159 20.1926 0.963222C19.4287 0.666684 18.5581 0.462661 17.2789 0.406929C15.9997 0.345238 15.5911 0.333984 12.3305 0.333984C9.07294 0.333984 8.66138 0.345238 7.38218 0.406929C6.10591 0.462661 5.23592 0.666684 4.46853 0.963222C3.68215 1.27159 3.01319 1.68021 2.34722 2.34619C1.67826 3.01515 1.26964 3.6841 0.961846 4.47346C0.665308 5.23431 0.463687 6.10787 0.401996 7.38649C0.346264 8.66569 0.332031 9.07489 0.332031 12.3355C0.332031 15.5931 0.346264 16.0017 0.401996 17.2809C0.463687 18.5571 0.665308 19.4301 0.961846 20.1945C1.26964 20.9809 1.67826 21.6528 2.34722 22.3188C3.01319 22.9848 3.68215 23.3964 4.46853 23.7042C5.23592 24.0007 6.10591 24.2023 7.38218 24.261C8.66138 24.3198 9.07294 24.334 12.3305 24.334C15.5911 24.334 15.9997 24.3198 17.2789 24.261C18.5581 24.2023 19.4287 24.0007 20.1926 23.7042C20.9819 23.3964 21.6509 22.9848 22.3168 22.3188C22.9858 21.6528 23.3944 20.9809 23.6992 20.1945C23.9987 19.4301 24.2004 18.5571 24.2591 17.2809C24.3178 16.0017 24.332 15.5931 24.332 12.3355C24.332 9.07489 24.3178 8.66569 24.2591 7.38649V7.38649Z"
        fill="url(#paint1_linear_4092_44236)"
      />
      <path
        d="M12.3318 16.3327C10.1239 16.3327 8.33233 14.544 8.33233 12.3361C8.33233 10.1246 10.1239 8.33366 12.3318 8.33366C14.5404 8.33366 16.3343 10.1246 16.3343 12.3361C16.3343 14.544 14.5404 16.3327 12.3318 16.3327V16.3327ZM12.3318 6.17022C8.92834 6.17022 6.17188 8.9326 6.17188 12.3361C6.17188 15.7366 8.92834 18.4961 12.3318 18.4961C15.7353 18.4961 18.4948 15.7366 18.4948 12.3361C18.4948 8.9326 15.7353 6.17022 12.3318 6.17022Z"
        fill="url(#paint2_linear_4092_44236)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_4092_44236"
          x1="0.549877"
          y1="24.0855"
          x2="22.3345"
          y2="2.30101"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#FFD521" />
          <stop offset="0.05" stopColor="#FFD521" />
          <stop offset="0.501119" stopColor="#F50000" />
          <stop offset="0.95" stopColor="#B900B4" />
          <stop offset="0.950079" stopColor="#B900B4" />
          <stop offset="1" stopColor="#B900B4" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_4092_44236"
          x1="0.548508"
          y1="24.1157"
          x2="22.351"
          y2="2.31328"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#FFD521" />
          <stop offset="0.05" stopColor="#FFD521" />
          <stop offset="0.501119" stopColor="#F50000" />
          <stop offset="0.95" stopColor="#B900B4" />
          <stop offset="0.950079" stopColor="#B900B4" />
          <stop offset="1" stopColor="#B900B4" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_4092_44236"
          x1="0.555449"
          y1="24.117"
          x2="22.3526"
          y2="2.31976"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#FFD521" />
          <stop offset="0.05" stopColor="#FFD521" />
          <stop offset="0.501119" stopColor="#F50000" />
          <stop offset="0.95" stopColor="#B900B4" />
          <stop offset="0.950079" stopColor="#B900B4" />
          <stop offset="1" stopColor="#B900B4" />
        </linearGradient>
      </defs>
    </svg>
  );
}

<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"></svg>;
